<template>
  <div class="selection-box" :class="{ 'selection-box--active': active, 'selection-box--disabled': disabled }">
    <div class="row align-items-center">
      <div class="col-6 col-lg-3 order-2 order-lg-1">
        <slot name="left"></slot>
      </div>
      <div class="col-12 col-lg-6 order-1 order-lg-2">
        <slot name="middle"></slot>
      </div>
      <div class="col-6 col-lg-3 order-1 order-lg-3">
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CiSelectionBox',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
<style lang="scss" scoped>
.selection-box {
  background: white;
  border-radius: 4px;
  border: 1px solid rgba(155, 155, 155, 0.5);
  box-shadow: 0 2px 23px 0 #ededed;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: relative;
  transition: border 0.4s ease;

  @include media-breakpoint-up(lg) {
    padding: 25px;
  }

  &.selection-box--active,
  .no-touch &:hover {
    border-color: $primary-green;
  }

  &.selection-box--disabled {
    cursor: not-allowed;
    border: 1px solid #f8e71c;

    .no-touch &:hover {
      border: 1px solid #f8e71c;
    }
  }
}
</style>
